<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  buttonTheme?: 'Primary' | 'Secondary' | 'Transparent-Teksty' | 'Background-2' | string
  arrow?: boolean
  href?: string
  submit?: boolean
  download?: boolean
  target?: string
}>()

const base = 'px-8 py-5 flex items-center gap-8 rounded-full cursor-pointer items-center justify-center transition-all duration-300 text-Button'

const themeClass = computed(() => {
  switch (props.buttonTheme) {
    case 'Primary':
      return `bg-Primary text-white group-hover:bg-background-2 group-hover:text-Tekst ${props.download ? 'group-hover:outline group-hover:outline-Teksty' : ''}`
    case 'Secondary':
      return `bg-Secondary text-white group-hover:bg-background-2 group-hover:text-Tekst ${props.download ? 'group-hover:outline group-hover:outline-Teksty' : ''}`
    case 'Transparent-Teksty':
      return 'outline outline-Teksty group-hover:bg-background-2'
    case 'Background-2':
      return 'bg-background-2 group-hover:bg-white group-hover:outline group-hover:outline-Teksty group-hover:text-Tekst'
    default:
      return ''
  }
})

const ArrowThemeClass = computed(() => {
  switch (props.buttonTheme) {
    case 'Primary':
      return 'text-white group-hover:text-Tekst!'
    case 'Secondary':
      return 'text-white group-hover:text-Tekst!'
    case 'Transparent-Teksty':
      return 'text-Tekst group-hover:text-Tekst!'
    case 'Background-2':
      return 'text-Tekst group-hover:text-Tekst!'
    default:
      return ''
  }
})
</script>

<template>
  <NuxtLink
    v-if="!props.submit && !props.download"
    :to="href || ''"
    class="group"
    :target="props?.target"
  >
    <div :class="[base, themeClass]">
      <slot />
      <i
        v-if="props.arrow"
        class="pi pi-arrow-right text-2xl! transition-all duration-300"
        :class="ArrowThemeClass"
      />
    </div>
  </NuxtLink>

  <a
    v-else-if="props.download"
    :href="href"
    :target="props?.target"
    download
    class="group"
  >
    <div :class="[base, themeClass]">
      <slot />
      <i
        v-if="props.arrow"
        class="pi pi-download text-2xl! transition-all duration-300"
        :class="ArrowThemeClass"
      />
    </div>
  </a>

  <button
    v-else
    type="submit"
    class="group"
  >
    <div :class="[base, themeClass]">
      <slot />
      <i
        v-if="props.arrow"
        class="pi pi-arrow-right text-2xl! transition-all duration-300"
        :class="ArrowThemeClass"
      />
    </div>
  </button>
</template>
